import { useAuth0 } from '@auth0/auth0-react'
import { createContext, useContext, useEffect, useState } from 'react'
import { Buffer } from 'buffer'
import { datadogRum } from '@datadog/browser-rum'

interface AuthContextInterface {
  accessToken: string
  permissions: string[]
}

export const AuthContext = createContext<AuthContextInterface>(
  {} as AuthContextInterface
)

interface AuthProviderProps {
  children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { user, getAccessTokenSilently } = useAuth0()
  const [accessToken, setAccessToken] = useState<string>('')
  const [permissions, setPermissions] = useState<string[]>([])

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      const rawPayload = token.split('.')[1]
      const buf = Buffer.from(rawPayload, 'base64')
      const payload = JSON.parse(buf.toString())
      const isProd = window.location.hostname === 'lupini.allarahealth.com'

      setPermissions(payload.permissions ?? [])
      setAccessToken(token)

      if (isProd) {
        datadogRum.setUser({
          id: user?.id || '',
          phone: user?.phone_number,
          email: user?.email,
        })
        datadogRum.startSessionReplayRecording()
      }
    })
  }, [])

  return (
    <AuthContext.Provider value={{ accessToken, permissions }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuthContext = (): AuthContextInterface =>
  useContext(AuthContext)
